import { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import styles from './social-search.module.css';
import defaultProfile2 from '../images/default-profile2.jpg';


const SocialSearch = ({socialType,socialId}) => {
    const [members, setMembers] = useState([]);
    const [filteredMembers, setFilteredMembers] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [showFilters, setShowFilters] = useState(false);
    const token = useMemo(() => localStorage.getItem('token'), []);
    const navigate = useNavigate();

    const [filters, setFilters] = useState({
        location: '',
        toLearn: '',
        toTeach: '',
        personalityType: '',
        timeAvailability: ''
    });
    const [showMembers, setShowMembers] = useState(false);
    const [sortByDistance, setSortByDistance] = useState(false);
    const [myLocation, setMyLocation] = useState({});
    const [locationError, setLocationError] = useState('');

    useEffect(() => {
        const fetchClubMembers = async () => {
            try {
                const response = await axios.get(`/api/${socialType}/${socialId}/members`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                
                setMembers(response.data.members);
                setFilteredMembers(response.data.members);
            } catch (error) {
                // console.error('Error fetching members:', error.message);
            }
        };

        const fetchCurrentUser = async () => {
            try {
                const response = await axios.get('/api/authApplicant/myLocation', {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setMyLocation(response.data.location);
            }
            catch (error) {
                console.error('Error fetching current user:', error.message);
            }
        };

        fetchCurrentUser();

        if (socialId && token) {
            fetchClubMembers();
        }
    }, [socialId, token]);


    const calculateDistance = (loc1, loc2) => {
        if (!loc1 || !loc2) return Infinity;
        
        if (loc1.lat && loc1.lng && loc2.lat && loc2.lng) {
            const R = 6371; 
            const dLat = (loc2.lat - loc1.lat) * Math.PI / 180;
            const dLon = (loc2.lng - loc1.lng) * Math.PI / 180;
            const a = Math.sin(dLat/2) * Math.sin(dLat/2) +
                     Math.cos(loc1.lat * Math.PI / 180) * Math.cos(loc2.lat * Math.PI / 180) *
                     Math.sin(dLon/2) * Math.sin(dLon/2);
            const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
            return R * c;
        }
        
        const loc1Lower = loc1.toLowerCase?.() || String(loc1).toLowerCase();
        const loc2Lower = loc2.toLowerCase?.() || String(loc2).toLowerCase();
        
        if (loc1Lower === loc2Lower) return 0;
        
        const loc1Parts = loc1Lower.split(',').map(p => p.trim());
        const loc2Parts = loc2Lower.split(',').map(p => p.trim());
        
        for (let i = 0; i < Math.min(loc1Parts.length, loc2Parts.length); i++) {
            if (loc1Parts[i] === loc2Parts[i]) {
                return 50 * (loc1Parts.length - i); 
            }
        }
        
        return 1000;
    };

    
    useEffect(() => {
        let result = members;

        if (searchTerm) {
            result = result.filter(member =>
                member.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                member.emailOrPhone?.toLowerCase().includes(searchTerm.toLowerCase())
            );
        }

        if (filters.location) {
            result = result.filter(member =>
                member.location?.toLowerCase().includes(filters.location.toLowerCase())
            );
        }

        if (filters.toLearn) {
            // result = result.filter(member =>
            //     member.toLearn?.some(skill =>
            //         skill.toLowerCase().includes(filters.toLearn.toLowerCase())
            //     )
            // );
            result = result.filter(member =>
                member.toLearn?.includes(filters.toLearn.toLowerCase())
            );
        }

        if (filters.toTeach) {
            result = result.filter(member =>
                member.toTeach?.includes(filters.toTeach.toLowerCase())
            );
        }

        if (filters.personalityType) {
            result = result.filter(member =>
                member.personalityType?.toLowerCase() === filters.personalityType.toLowerCase()
            );
        }

        if (filters.timeAvailability) {
            result = result.filter(member =>
                member.timeAvailability?.toLowerCase() === filters.timeAvailability.toLowerCase()
            );
        }

        if (sortByDistance) {
            result = [...result].sort((a, b) => {
                const distA = calculateDistance(myLocation, a.location);
                const distB = calculateDistance(myLocation, b.location);
                return distA - distB;
            });
        }

        setFilteredMembers(result);
    }, [searchTerm, filters, members, sortByDistance]);

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
        setShowMembers(true);
        // if(!e.target.value){
        //     setShowMembers(false);
        // }
    };


    const handleFilterChange = (filterName, value) => {
        setFilters(prev => ({
            ...prev,
            [filterName]: value
        }));
        setShowMembers(true);
    };

    const handleSortByLocation = () => {
        if (!myLocation) {
            setLocationError('Please add your location in profile settings to sort by nearest location');
            return;
        }

        setSortByDistance(!sortByDistance);
        setLocationError('');
        setShowMembers(true);

        if (!sortByDistance) {
            setFilters(prev => ({
                ...prev,
                location: ''
            }));
        }
    };

    const clearFilters = () => {
        setFilters({
            location: '',
            toLearn: '',
            toTeach: '',
            personalityType: '',
            timeAvailability: ''
        });
        setSearchTerm('');
        setSortByDistance(false);
        setLocationError('');
    };

    
    const handleProfileClick = async (networkId) => {
        const profileStatus = 'friends';
        // console.log("profileStatus:hp", profileStatus);
        // setStatus(profileStatus)
        // console.log("status:hp",status)
        navigate(`/profile/${networkId}`, { state: profileStatus });  
    };

    const activeFilterCount = Object.values(filters).filter(val => val !== '').length;



  return (
    <>
        <div className={styles.searchMembersContainer}>
            <div className={styles.searchBar}>
                <input
                    type="text"
                    className={styles.searchMembersInput}
                    placeholder="Search members by name..."
                    value={searchTerm}
                    onChange={handleSearchChange}
                />
                <button title={showFilters ? "Close Filters": "Show Filters" }
                    className={styles.filterToggleButton}
                    onClick={() => setShowFilters(!showFilters)}
                >
                    Filters {activeFilterCount > 0 && `(${activeFilterCount})`}
                </button>
            </div>

            {showMembers &&

            <div className={styles.resultsInfo} onClick={() => setShowMembers(!showMembers)}>
                Showing {filteredMembers.length} of {members.length} members
            </div>
}
            {showFilters && 
                <div className={styles.filtersPanel}>
                    <div className={styles.filterRow}>
                        <div className={styles.filterGroup}>
                            <label>Location</label>
                            <div className={styles.locationFilter}>
                             <input
                                    type="text"
                                    placeholder="Enter location..."
                                    value={filters.location}
                                    onChange={(e) => handleFilterChange('location', e.target.value)}
                                    disabled={sortByDistance}
                                />
                                <button 
                                    onClick={handleSortByLocation} 
                                    className={`${styles.sortByNearestLocationBtn} ${sortByDistance ? styles.active : ''}`}
                                    title={!myLocation ? 'Add your location to use this feature' : ''}
                                >
                                    {sortByDistance ? '✓ Sorted by Distance' : 'Sort by Nearest'}
                                </button>
                            </div>
                            {locationError && (
                                <span className={styles.locationError}>{locationError}</span>
                            )}
                        </div>

                        <div className={styles.filterGroup}>
                            <label>To Learn</label>
                            <input
                                type="text"
                                placeholder="Skills they want to learn..."
                                value={filters.toLearn}
                                onChange={(e) => handleFilterChange('toLearn', e.target.value)}
                            />
                        </div>

                        <div className={styles.filterGroup}>
                            <label>To Teach</label>
                            <input
                                type="text"
                                placeholder="Skills they can teach..."
                                value={filters.toTeach}
                                onChange={(e) => handleFilterChange('toTeach', e.target.value)}
                            />
                        </div>
                    </div>

                    <div className={styles.filterRow}>
                        <div className={styles.filterGroup}>
                            <label>Personality Type</label>
                            <select
                                value={filters.personalityType}
                                onChange={(e) => handleFilterChange('personalityType', e.target.value)}
                            >
                                <option value="">All Types</option>
                                <option value="INTJ">INTJ</option>
                                <option value="INTP">INTP</option>
                                <option value="ENTJ">ENTJ</option>
                                <option value="ENTP">ENTP</option>
                                <option value="INFJ">INFJ</option>
                                <option value="INFP">INFP</option>
                                <option value="ENFJ">ENFJ</option>
                                <option value="ENFP">ENFP</option>
                                <option value="ISTJ">ISTJ</option>
                                <option value="ISFJ">ISFJ</option>
                                <option value="ESTJ">ESTJ</option>
                                <option value="ESFJ">ESFJ</option>
                                <option value="ISTP">ISTP</option>
                                <option value="ISFP">ISFP</option>
                                <option value="ESTP">ESTP</option>
                                <option value="ESFP">ESFP</option>
                                <option value="soft">soft</option>
                                <option value="bold">bold</option>
                                <option value="introvert">introvert</option>
                                <option value="quickLearner">quickLearner</option>
                                <option value="slowLearner">slowLearner</option>
                                <option value="lazyLearner">lazyLearner</option>
                                <option value="activeLearner">activeLearner</option>
                                <option value="queryDiminisher">queryDiminisher</option>
                                <option value="queryAcknowledger">queryAcknowledger</option>
                                <option value="soulCrusher">soulCrusher</option>
                                <option value="soulExpander">soulExpander</option>
                                <option value="respecting">respecting</option>
                                <option value="crushing">crushing</option>
                                <option value="dreamSupporter">dreamSupporter</option>
                                <option value="dreamDenier">dreamDenier</option>
                                <option value="deepSpiritual">deepSpiritual</option>
                                <option value="atheist">atheist</option>
                                <option value="bhakt">bhakt</option>
                            </select>
                        </div>

                        <div className={styles.filterGroup}>
                            <label>Time Availability</label>
                            <select
                                value={filters.timeAvailability}
                                onChange={(e) => handleFilterChange('timeAvailability', e.target.value)}
                            >
                                <option value="">All Times</option>
                                <option value="weekdays_mornings">Weekdays Mornings</option>
                                <option value="weekdays_afternoons">Weekdays Afternoons</option>
                                <option value="weekdays_evenings">Weekdays Evenings</option>
                                <option value="weekends_mornings">Weekends Mornings</option>
                                <option value="weekends_afternoons">Weekends Afternoons</option>
                                <option value="weekends_evenings">Weekends Evenings</option>
                                <option value="flexible">Flexible</option>
                            </select>
                        </div>

                        <div className={styles.filterActions}>
                            <button 
                                className={styles.clearFiltersButton}
                                onClick={clearFilters}
                            >
                                Clear All
                            </button>
                        </div>
                    </div>
                </div>
                }
            {showMembers &&
                <div className={styles.membersList}>
                    {filteredMembers.map(member => (
                        <div key={member._id} className={styles.memberCard} onClick={() => handleProfileClick(member._id)}>
                            <>
                            <div className={styles.memberInfo}>
                            <img title={member.name} src={member.profilePicture ? member.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : defaultProfile2}alt="pfp" className={styles.networkProfilePicture} />
                            <h3>{member.name}</h3>
                            </div>
                            <p>Location: {member.location || 'Not specified'}</p>
                            <p>To Learn: {member?.toLearn || 'None'}</p>
                            <p>To Teach: {member?.toTeach|| 'None'}</p>
                            <p>Personality: {member.personalityType || 'Not specified'}</p>
                            <p>Availability: {member.timeAvailability || 'Not specified'}</p>
                            </>
                        </div>
                    ))}
                </div>
            }
        </div>

        
       
        </>
  );
}
export default SocialSearch;